import React from 'react';
import { ScrollView, View } from 'react-native';
import sections from '~/utils/terms';

import MarisaServiceLogoSVG from '~/assets/svgs/marisaServicesLogo.svg';
import { AccordionGroup, Button, Text } from '~/components';
import useAppNavigation from '~/hooks/useAppNavigation';

const TermsAndConditions: React.FC = () => {
  const { goBack } = useAppNavigation();

  return (
    <View className="flex-row h-[100vh] overflow-hidden">
      <View className="flex-1 bg-primary-600 items-center justify-center hidden lg:flex">
        <MarisaServiceLogoSVG />
      </View>

      <View className="flex-1 bg-white items-center justify-center">
        <Text className="text-xl text-center text-gray-700 mt-6 uppercase font-medium">
          Termos de Uso e Política de Privacidade
        </Text>

        <ScrollView className="mt-10 pb-6">
          <View className="px-24 items-center">
            <AccordionGroup sections={sections} />

            <Button onPress={goBack} className="mt-8 w-[450px]">
              Voltar
            </Button>
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default TermsAndConditions;
